import { Box, Button, Flex, MantineStyleProps, useMantineColorScheme } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ChoosePlanModal } from "./ChoosePlanModal";

import { Modal, TextSerif } from "@/components/elements";
import { global_settings } from "@/config";

import type { FC } from "react";

type PlanLimitsModalProps = {
  isOpen: boolean;
  onClose?: () => void;
} & MantineStyleProps;

export const PlanLimitsModal: FC<PlanLimitsModalProps> = ({ isOpen, onClose, ...props }) => {
  const { t } = useTranslation();
  const [isPlansOpen, setPlansOpen] = useState(false);

  /* Theme */
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const colorText = isDark ? "gray.4" : "inherit";

  const description = global_settings.enablePayments
    ? t("plans.limitReached")
    : t("plans.limitReachedNoPayments");

  return (
    <>
      <Modal
        opened={isOpen}
        onClose={onClose ?? (() => {})}
        type="warning"
        title={t("plans.limitReachedTitle")}
        centered
        size="lg"
        style={{ width: "100%", maxWidth: "100%", padding: "0px" }}
        {...props}
      >
        <TextSerif fz="sm" maw="480px" c={colorText}>
          {description}
        </TextSerif>

        <Flex justify="center" gap="lg" mx="auto" pt="1.5em" pb="sm" maw={500}>
          <Button
            variant="outline"
            w="50%"
            maw="100%"
            onClick={onClose}
            aria-label={t("common.cancel")}
          >
            {t("common.cancel")}
          </Button>

          {global_settings.enablePayments ? (
            <Button
              w="50%"
              maw="100%"
              onClick={() => {
                onClose?.();
                setPlansOpen(true);
              }}
              aria-label={t("plans.choosePlan")}
            >
              {t("plans.choosePlan")}
            </Button>
          ) : null}
        </Flex>
      </Modal>

      <Modal
        opened={isPlansOpen}
        onClose={() => setPlansOpen(false)}
        size="fit-content"
        maw="100%"
        centered
        withCloseButton={false}
      >
        <Box w="100%" px={{ base: "0px", md: "md", lg: "lg" }}>
          <ChoosePlanModal
            isOpen={isPlansOpen}
            onClose={() => setPlansOpen(false)}
            title={t("plans.changePlanAnytime")}
          />
        </Box>
      </Modal>
    </>
  );
};
